import React, { useEffect, useState, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { RouterRoutes } from "./routes";
import AppProvider from "./hooks";
import TagManager from "react-gtm-module";
import { FrontendApi, api, resolveUrl } from "./config/apis";
import { TrackingProvider } from "./components/TimeTracking";
import Loader from "./components/loader/FormLoader"; // Import the MUI Loader component

const RouterProvider = React.lazy(() => import("react-router-dom").then(module => ({ default: module.RouterProvider })));



const App = () => {
  const [gtmCode, setGtmCode] = useState<string | null>(null);

  useEffect(() => {
    const fetchMetaData = async () => {
      try {
        const res = await api.get(
          resolveUrl(FrontendApi.META_TAGS_VIEW, "gtm-code")
        );
        setGtmCode(res.data.keywords);
      } catch (error) {
        console.error(error);
      }
    };
    fetchMetaData();
  }, []);

  useEffect(() => {
    if (gtmCode) {
      TagManager.initialize({ gtmId: gtmCode });
      TagManager.dataLayer({
        dataLayer: {
          event: "pageview",
          page: window.location.pathname + window.location.search,
        },
      });
    }
  }, [gtmCode]);

  useEffect(() => {
    const unsubscribe = RouterRoutes.subscribe((location: any) => {
      TagManager.dataLayer({
        dataLayer: {
          event: "pageview",
          page: location.location.pathname + location.location.search,
        },
      });
    });
    return () => unsubscribe();
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <AppProvider>
        <TrackingProvider>
          <RouterProvider router={RouterRoutes} />
        </TrackingProvider>
      </AppProvider>
    </Suspense>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<App />);
